import randomstring from 'randomstring';

export const CLASSTING_ACCOUNTS_URL = process.env.VUE_APP_CLASSTING_ACCOUNTS_URL;
export const CLASSTING_OIDC_CLIENT_ID = process.env.VUE_APP_CLASSTING_OIDC_CLIENT_ID;
export const CLASSTING_REDIRECT_URI = `${window.location.origin}/oauth_callback/classting`;
export const CT_FIREBASE_AUTH_URL = process.env.VUE_APP_CT_FIREBASE_AUTH_URL;
export const CLASSTING_URL = process.env.VUE_APP_CLASSTING_URL;
export const MINERVA_API_URL = process.env.VUE_APP_MINERVA_API_URL;
export const MINERVA_BASE_URL = process.env.VUE_APP_MINERVA_BASE_URL;
export const EDGE_RANKING_API_URL = process.env.VUE_APP_EDGE_RANKING_API_URL;
export const CT_PERF_URL = process.env.VUE_APP_CT_PERF_URL;
export const CLASSTING_PAY_WEB = process.env.VUE_APP_CLASSTING_PAY_WEB;
export const CLASSTING_AI_WEB = process.env.VUE_APP_CLASSTING_AI_WEB;
export const LOG_URL = process.env.VUE_APP_LOG_URL;
export const LOG_BASE_URL = process.env.VUE_APP_LOG_BASE_URL;
export const CT_FIREBASE_CONFIG = {
  apiKey: process.env.VUE_APP_CT_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_CT_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_CT_FIREBASE_DATABASE_URL,
  projectId: process.env.VUE_APP_CT_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_CT_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_CT_FIREBASE_MESSAGING_SENDER_ID,
};
export const CONTENT_REPORTS_CONFIG = process.env.VUE_APP_CONTENT_REPORTS_URL;
export const GA_ID = process.env.VUE_APP_GA_ID;
export const CLASSTING_FULL_AUTH_URL = [
  `${CLASSTING_ACCOUNTS_URL}/oidc/auth`,
  `?client_id=${CLASSTING_OIDC_CLIENT_ID}`,
  '&response_type=id_token+token',
  '&scope=openid+email+profile',
  `&nonce=${randomstring.generate(10)}`,
  `&redirect_uri=${CLASSTING_REDIRECT_URI}`,
].join('');
export const AI_FIRESTORE_COLLECTION = process.env.VUE_APP_AI_FIRESTORE_COLLECTION;
export const CT_APP_PACKAGE_NAME = process.env.VUE_APP_CT_APP_PACKAGE_NAME;
export const SENTRY_DSN = process.env.VUE_APP_SENTRY_DSN;
export const NEWCLASS_BASE_URL = process.env.VUE_APP_NEWCLASS_BASE_URL;
